







































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Aisle from "../../../store/entities/aisle";
import AppConsts from "../../../lib/appconst";
import util from "../../../lib/util";
@Component
export default class CreateAisle extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  aisle: Aisle = new Aisle();
  spinShow = false;
  rooms=[];
  
  save() {
    (this.$refs.aisleForm as any).validate(async (valid: boolean) => {
          if (valid) {
              this.$Modal.confirm({
                title:this.L('Tips'),
                content:this.L('Confirm.CreateAisle'),
                okText:this.L('Yes'),
                cancelText:this.L('No'),
                onOk:async()=>{
                    this.spinShow=true;
                    try {
                          await this.$store.dispatch({
                              type: "aisle/create",
                              data: this.aisle
                            });
                        Util.showSuccessMsg(this,'Success.CreateAisle');
                        this.$emit("save-success");
                        this.onGoBack();
                        this.spinShow=false;
                    } catch (error) {
                       this.spinShow=false; 
                    }
                }
        });
      }
    });
    
  }
   onGoBack(){
      (this.$refs.aisleForm as any).resetFields();
      this.$emit("input", false);
      this.$root.$router.push({name: 'aisle'});
  }
   async getRooms(){
             await this.$store.dispatch({
                    type:'room/getRoomsForSelect',
                    data:{ hasAllItem:false}
                }).then(result=>{
                    this.rooms = result;
                    this.aisle.roomCode = this.rooms.length>0 ? this.rooms[0].id : '';
                });
        }
  convertValueLessThanZero(value)
  {
      if(Util.isEmpty(value.toString()))
        return value;
      var decimalValue = parseFloat(value);
      if( Util.isNull(decimalValue))
      {
          return 0;
      }
      decimalValue = decimalValue<0? 0: decimalValue;
      return decimalValue;
  }
  aisleRule = {
    id: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Code")),
        trigger: "blur"
      }
    ],
    roomCode: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Room")),
        trigger: "blur"
      }
    ],
     height: [
      {
        required: true,
         type:'number',
        message: this.L("Error.RequiredField", undefined, this.L("Height")),
        trigger: "blur"
      }
    ], length: [
      {
        required: true,
        type:'number',
        message: this.L("Error.RequiredField", undefined, this.L("Length")),
        trigger: "blur"
      }
    ], width: [
      { 
        required: true,
         type:'number',
        message: this.L("Error.RequiredField", undefined, this.L("Width")),
        trigger: "blur"
      }
    ]
  };
 
  async created(){
      await this.getRooms();
  }
}
